export default "__VITE_ASSET__BqKaGbiE__"